<template>
  <div class="content-c">
    <div style="padding: 10px">
      <div class="bank-card f-t-13 l-h-20">
        <p>{{ $lang.BankInfo_txt12 }}</p>
        <p>{{ $lang.account }}</p>
        <div
          class="bank-card-i d-flex-s"
          v-for="(item, index) in bankCardList"
          :key="index"
        >
          <div class="d-flex">
            <div class="m-l-10">
              <p>
                <span class="font-color"> {{ item.bankName }}</span>
              </p>
              <p class="font-color">
                <span v-if="item.isSee">{{ item.bankCard }}</span>
                <span v-else>{{ item.bankCard }}</span>
                <i
                  class="icon iconfont icon-Vector m-l-10"
                  style="font-size: var(--vk-fs-15)"
                  @click="copyText(item.bankCard)"
                ></i>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bank-card-b">
      <div @click="showBankF" class="bank-card-add-btn">
        <div class="d-flex" style="align-items: center; justify-content: center; flex-direction: column">
          <img
            src="../../assets/img/home/addBank.png"
            width="150"
            height="50"
            class="m-b-10"
          />
          <span class="add-bank-text">{{ $lang.BankInfo_txt13 }}</span>
        </div>
      </div>

      <van-popup
        v-model="showBank"
        class="custom-popup"
        :closeable="false"
        :close-on-click-overlay="false"
      >
        <div class="content-card">
          <p class="f-t-14 t-c m-b-20">
            {{ $lang.BankInfo_txt13 }} {{ $lang.account }}
          </p>
          <van-field
            v-model="realName"
            :placeholder="$lang.common_txt46"
            class="custom-field m-b-20"
            :readonly="realNameIsf"
          >
            <template #left-icon>
              <i class="icon iconfont icon-shiming m-r-5"></i>
            </template>
          </van-field>
          <div class="p-r" @click="selectF">
            <van-field v-model="bankName" class="custom-field m-t-20" readonly>
              <template #left-icon>
                <i class="icon iconfont icon-renyuan m-r-5"></i>
              </template>
              <template #right-icon>
                <van-icon
                  name="arrow-down"
                  :class="{ 'arrow-up': showSelect }"
                />
              </template>
            </van-field>
            <div v-if="showSelect" class="bank-select">
              <p
                class="bank-select--i"
                v-for="(item, index) in columns"
                :key="index"
                @click="getSelect(index, item)"
                :class="{ 'select-active': index === selectIndex }"
              >
                {{ item.label }}
              </p>
            </div>
          </div>

          <van-field
            v-model="bankCard"
            :placeholder="
              ['Otbet','Kkbet'].includes(GET_PLATFORM) ? $lang.common_txt47 : $lang.common_txt7
            "
            class="custom-field m-t-20 xg-in no-copy"
            :maxlength="['Otbet','Kkbet'].includes(GET_PLATFORM) ? 100 : 11"
          >
            <template #left-icon>
              <i
                v-if="['Otbet','Kkbet'].includes(GET_PLATFORM)"
                class="icon iconfont icon-yinhangkaweihao m-r-5"
              ></i>
              <span v-else>{{ GET_AREACODE }}</span>
            </template>
          </van-field>
          <van-button
            size="large"
            class="custom-button m-t-30"
            :disabled="submitting"
            @click="submit"
          >
            {{ $lang.Confirmar }}
          </van-button>
        </div>
        <div class="t-c m-t-10">
          <i @click="showBank = false" class="icon iconfont icon-guanbi"></i>
        </div>
      </van-popup>
    </div>
  </div>
</template>
<script>
import {
  AddBankCardInit,
  AddBankCard,
  BankCardInfo,
  WithdrawInit
} from '@/api/modules/withdraw'
import {
  contentOf,
  failMessage,
  handleNeedLogin,
  isOk,
  normalizeBankCardList,
  normalizeBankOptions
} from './paymentFlow'
import { isSafeWriteSuccess, hasStrictWriteProof } from '@/views/details/recharge/safeFlow'
import { safeGetStorageItem, safeLocalStorage } from '@/utils/safeStorage'
import { copyTextToClipboard } from '@/components/share/shareSafety'

function guardedLocalStorage() {
  try {
    return safeLocalStorage()
  } catch (e) {
    return null
  }
}

function normalizeRechargeBankCardList(cards) {
  if (typeof normalizeBankCardList === 'function') return normalizeBankCardList(cards)
  return Array.isArray(cards) ? cards : []
}

function normalizeRechargeBankOptions(list) {
  if (typeof normalizeBankOptions === 'function') return normalizeBankOptions(list)
  return (Array.isArray(list) ? list : []).map((item) => ({
    value: item.bankId || item.id || item.bankCode || item.code || '',
    label: item.bankName || item.shortName || item.name || item.label || ''
  })).filter((item) => item.value && item.label)
}

export default {
  name: 'BankInfoTab2',
  components: {},
  props: {},
  data() {
    return {
      bankName: '',
      realName: '',
      realNameIsf: false,
      bankId: null,
      showBank: false,
      bankCard: '',
      columns: [],
      showSelect: false,
      selectIndex: 0,
      bankCardList: [],
      vipLevel: null,
      cpf: '',
      cpfIsf: false,
      loading: false, // 补充loading初始值
      submitting: false
    }
  },
  created() {},
  mounted() {
    if (!this.ensureLogin()) return
    this.WithdrawInit()
    this.BankCardInfo()
    this.AddBankCardInit()
  },
  watch: {},
  methods: {
    safeToast(payload) {
      if (typeof this.$toast === 'function') {
        this.$toast(payload)
      }
    },
    getToken() {
      return safeGetStorageItem(guardedLocalStorage(), 'token')
    },
    ensureLogin() {
      if (this.getToken()) return true
      if (this.$bus) this.$bus.$emit('openLogin')
      return false
    },
    showRequestError(data) {
      if (handleNeedLogin(this, data)) return
      this.safeToast({
        message: failMessage(data, this.$lang.common_txt376 || this.bankListUnavailableMessage()),
        icon: 'cross'
      })
    },
    async WithdrawInit() {
      if (!this.ensureLogin()) return
      try {
        const data = await WithdrawInit()
        if (isOk(data)) {
          this.vipLevel = Number(contentOf(data).vipLevel || 0)
        } else {
          this.showRequestError(data)
        }
      } catch (e) {
        this.showRequestError(e)
      }
    },
    // 格式化银行卡号
    formatCardNumber(cardNumber) {
      if (!cardNumber) return ''
      const length = cardNumber.length
      if (length <= 4) return cardNumber
      const stars = '******'
      return stars + cardNumber.slice(-4)
    },
    copyText(v) {
      try {
        const copied = copyTextToClipboard(v)
        if (typeof this.safeToast === 'function') {
          this.safeToast({
            message: copied ? this.$lang.Sucesso : (this.$lang.copy_failed || 'Copy failed'),
            icon: copied ? 'success' : 'cross'
          })
        }
      } catch (e) {
        const copied = false
        if (typeof this.safeToast === 'function') {
          this.safeToast({
            message: copied ? this.$lang.Sucesso : (this.$lang.copy_failed || 'Copy failed'),
            icon: copied ? 'success' : 'cross'
          })
        }
      }
    },
    bankListUnavailableMessage() {
      return this.$lang.bank_list_unavailable || 'This feature is temporarily unavailable. Please try again later.'
    },
    async showBankF() {
      if (!this.ensureLogin()) return
      if (this.bankCardList.length >= 5) {
        this.safeToast({
          message: this.$lang.common_txt376 || 'Bank card limit reached',
          icon: 'cross'
        })
        return
      }
      const ready = await this.AddBankCardInit()
      if (!ready) return
      this.showBank = true
    },
    async BankCardInfo() {
      if (!this.ensureLogin()) return
      this.loading = true
      try {
        const data = await BankCardInfo()
        if (isOk(data)) {
          const content = contentOf(data)
          this.bankCardList = normalizeRechargeBankCardList(content.bankCardList)
          this.bankCardList.forEach((i) => {
            this.$set(i, 'isSee', false)
          })
        } else {
          this.showRequestError(data)
        }
      } catch (e) {
        this.showRequestError(e)
      } finally {
        this.loading = false // 补充关闭loading
      }
    },
    // 验证银行卡号格式
    validateBankCard() {
      const bankCard = String(this.bankCard || '').trim()
      // 非非洲银行卡布局（Otbet/Kkbet）时才走 8-11 位短卡号校验
      if (!['Otbet', 'Kkbet'].includes(this.GET_PLATFORM)) {
        // 正则：8-11位数字，不以0开头
        const reg = /^[1-9]\d{7,10}$/
        if (!reg.test(bankCard)) {
          this.safeToast({
            message: this.$lang.common_txt376,
            icon: 'cross'
          })
          return false
        }
      } else if (bankCard.length < 4 || bankCard.length > 100) {
        this.safeToast({
          message: this.$lang.common_txt376,
          icon: 'cross'
        })
        return false
      }
      return true
    },
    async submit() {
      if (this.submitting) return
      if (!this.ensureLogin()) return
      if (!this.bankCard) {
        this.safeToast({
          message: this.$lang.BankInfo_txt16,
          icon: 'cross'
        })
        return
      }

      // 验证银行卡号格式
      if (!this.validateBankCard()) {
        return
      }

      if (!this.realName) {
        this.safeToast({
          message: this.$lang.common_txt46,
          icon: 'cross'
        })
        return
      }

      if (this.columns.length <= 0) {
        this.safeToast({
          message: this.bankListUnavailableMessage(),
          icon: 'cross'
        })
        return
      }

      if (!this.bankId || !this.bankName) {
        this.safeToast({
          message: this.$lang.BankInfo_txt13,
          icon: 'cross'
        })
        return
      }

      let submitBankCard = String(this.bankCard || '').trim()
      // // 非Otbet平台时拼接地区码
      // if (this.GET_PLATFORM !== 'Otbet' && this.GET_AREACODE) {
      //   submitBankCard = this.GET_AREACODE + submitBankCard
      // }

      let params = {
        bankName: this.bankName,
        bankId: this.bankId,
        bankCard: submitBankCard, // 使用拼接后的卡号
        realName: this.realName
      }
      this.submitting = true
      try {
        const data = await AddBankCard(params)
        if (isSafeWriteSuccess(data) && hasStrictWriteProof(data)) {
          this.showBank = false
          this.bankCard = ''
          this.BankCardInfo()
        } else {
          this.showRequestError(data)
        }
      } catch (e) {
        this.showRequestError(e)
      } finally {
        this.submitting = false
      }
    },
    getSelect(i, v) {
      this.bankId = v.value
      this.bankName = v.label
      this.selectIndex = i
    },
    async AddBankCardInit() {
      if (!this.ensureLogin()) return false
      try {
        const data = await AddBankCardInit()
        if (isOk(data)) {
          const content = contentOf(data)
          if (content.realName) {
            this.realName = content.realName
            this.realNameIsf = true
          } else {
            this.realNameIsf = false
          }

          const bankList = Array.isArray(content.bankList)
            ? content.bankList
            : []
          this.columns = normalizeRechargeBankOptions(bankList).filter((item) => item.value && item.label)
          // 防止bankList为空导致报错
          if (this.columns.length > 0) {
            this.getSelect(0, this.columns[0])
            return true
          } else {
            this.bankId = null
            this.bankName = ''
            this.selectIndex = 0
            this.showBank = false
            this.safeToast({
              message: this.bankListUnavailableMessage(),
              icon: 'cross'
            })
            return false
          }
        } else {
          this.showBank = false
          this.showRequestError(data)
          return false
        }
      } catch (e) {
        this.showBank = false
        this.showRequestError(e)
        return false
      }
    },
    selectF() {
      this.showSelect = !this.showSelect
    }
  }
}
</script>
<style lang="less" scoped>
.content-c {
  z-index: 8;
  padding-bottom: 20px;
  .content-card {
    padding: 10px 15px;
    border-radius: 12px;
    width: 90%;
    background: @cont-bg;
    margin: 0 auto;
  }
  .custom-popup {
    width: 100%;
    background: transparent;
  }
  .bank-card {
    background: @cont-bg;
    border-radius: 5px;
    border: 1px solid @border-color;
    padding: 10px;
  }
  .bank-card-b {
    width: 100%;
    background: transparent;
    padding: 0;
  }
  .bank-card-add-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #1e2532, #2e2a4e, #573798);
    border-radius: 16px;
    padding: 30px 20px;
    margin: 20px auto;
    width: 85%;
    cursor: pointer;
    transition: opacity 0.2s;
  }
  .bank-card-add-btn:active {
    opacity: 0.8;
  }
  .add-bank-text {
    color: #ffffff;
    font-size: var(--vk-fs-15);
    font-weight: bold;
  }
  .bank-card-bi {
    border: 1px solid @border-color;
    border-radius: 8px;
    padding: 10px 8px;
  }
  .bank-card-bim {
    background: #ffffff;
    padding: 5px;
    border-radius: 5px;
  }
  .iconfont {
    color: #ffffff;
    font-size: var(--vk-fs-xl);
  }
  .bank-select {
    position: absolute;
    padding: 10px 0;
    border: 1px solid @border-color;
    border-radius: 10px;
    width: 100%;
    background: @cont-bg;
    z-index: 9;
    color: @font-color;
    height: 150px;
    overflow-y: auto;
  }
  .bank-select--i {
    padding: 10px 10px;
  }
  .select-active {
    background: #3979e3;
    font-weight: bold;
    color: #ffffff;
  }
  .arrow-up {
    transform: rotate(-180deg);
  }
  .icon-guanbi {
    font-size: 32px;
    color: #ffffff;
  }
  .bank-card-i {
    border: 1px solid @border-color;
    padding: 5px;
    border-radius: 7px;
    margin-bottom: 5px;
  }
  .icon-yanjing {
    font-size: 28px;
    color: #076237;
  }
  .icon-a-Vector1 {
    font-size: var(--vk-fs-15);
    margin-right: 2px;
    color: #666666;
  }
}
.xg-in {
  ::v-deep .van-field__left-icon {
    margin-top: 2px;
  }
}
@media (min-width: 769px) {
  .bank-card-add-btn {
    width: var(--vk-pc-col);
  }
}
.no-copy {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
